
import React from 'react';
import { IconProps } from './IconProps';

const DeliveryIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M13 8h-2v4" />
    <path d="M12 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
  </svg>
);

export default DeliveryIcon;
